export default function FeaturedCategories() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-10">
          <div className="flex flex-col sm:flex-row sm:items-end gap-2 mb-2">
            <span className="font-heading text-xs font-semibold text-foreground-400 uppercase tracking-[0.3em] leading-relaxed">
              K A K O B U Y<br />F I N D S
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 text-center mt-6">
            Curated Research Hub
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-primary-500 rounded-2xl p-8 flex flex-col justify-between min-h-[320px] group hover:bg-primary-600 transition-colors duration-300">
            <div className="w-12 h-12 rounded-xl bg-foreground-800 flex items-center justify-center mb-6">
              <span className="text-background-50 font-heading text-xl font-bold">S</span>
            </div>
            <div>
              <h3 className="text-background-50 font-heading text-2xl md:text-3xl font-bold mb-3">
                Shoes Spreadsheet
              </h3>
              <p className="text-background-300 text-sm leading-relaxed">
                Discover the most comprehensive shoes research database with verified product listings and detailed comparison data.
              </p>
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-block mt-5 text-background-200 text-sm font-medium hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap border-b border-background-400 hover:border-background-50"
              >
                Explore Shoes &rarr;
              </a>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden min-h-[320px] group">
            <img
              src="https://readdy.ai/api/search-image?query=A%20beautifully%20draped%20oversized%20rust%20orange%20sweater%20with%20subtle%20cable%20knit%20texture%20lying%20across%20a%20light%20cream%20linen%20surface%2C%20soft%20window%20light%20casting%20gentle%20gradient%20shadows%2C%20editorial%20fashion%20photography%2C%20warm%20and%20cozy%20autumn%20aesthetic%2C%20rich%20textile%20detail%2C%20minimal%20composition%2C%20no%20person%20visible&width=800&height=900&seq=kakobuy-feat-v2-01&orientation=portrait"
              alt="Hoodies and Sweaters Spreadsheet Research"
              title="Hoodies and Sweaters Research Database"
              className="w-full h-full object-cover object-top absolute inset-0 transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute top-5 left-5">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-800">
                <i className="ri-t-shirt-line text-sm"></i>
                Apparel
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-background-50 font-heading text-2xl md:text-3xl font-bold mb-2">
                Hoodies &amp; Sweaters
              </h3>
              <a
                href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-block text-background-200 text-sm font-medium hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                View Collection &rarr;
              </a>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 flex flex-col justify-between min-h-[320px] group hover:bg-background-200 transition-colors duration-300">
            <div>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight mb-3">
                Jackets / Pants / Headwear
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Browse our extensive collection spanning jackets, pants, shorts, and headwear categories with detailed product research data.
              </p>
            </div>
            <div className="mt-6">
              <img
                src="https://readdy.ai/api/search-image?query=A%20thoughtfully%20styled%20flat%20lay%20of%20a%20lightweight%20olive%20utility%20jacket%20folded%20beside%20a%20classic%20charcoal%20baseball%20cap%20with%20subtle%20embroidery%20detail%2C%20placed%20on%20a%20warm%20cork%20surface%2C%20soft%20natural%20lighting%20from%20above%2C%20editorial%20catalog%20photography%2C%20refined%20casual%20aesthetic%2C%20earthy%20neutral%20color%20palette&width=600&height=500&seq=kakobuy-feat-v2-02&orientation=landscape"
                alt="Jackets Pants Headwear Spreadsheet Database"
                title="Jackets Pants Headwear Product Research"
                className="w-full h-48 object-cover object-top rounded-xl"
              />
              <div className="flex gap-3 mt-4">
                <a
                  href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex-1 text-center px-3 py-2 rounded-full bg-accent-500 text-background-50 text-xs font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Jackets
                </a>
                <a
                  href="https://kaspreadsheet.com/search-915/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex-1 text-center px-3 py-2 rounded-full border border-accent-500 text-accent-600 text-xs font-semibold hover:bg-accent-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Pants
                </a>
                <a
                  href="https://kaspreadsheet.com/search-916/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex-1 text-center px-3 py-2 rounded-full border border-accent-500 text-accent-600 text-xs font-semibold hover:bg-accent-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Headwear
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}